import { FunctionComponent } from "react";

export interface Props {
  className?: string;
  fill?: string;
  width?: number;
  height?: number;
}

const NewsletterIcon: FunctionComponent<Props> = ({
  className,
  fill = "currentColor",
  width = 20,
  height = 20,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.0001 5.98809C1.99998 5.99488 1.99997 6.00167 2.00007 6.00845V14C2.00007 15.1015 2.98022 16 4.18187 16H15.8181C17.0198 16 17.9999 15.1015 17.9999 14V6.00781C18 6.0015 18 5.99519 17.9999 5.98887C17.9933 4.89243 17.0157 4 15.8181 4H4.18187C2.98455 4 2.00714 4.89201 2.0001 5.98809ZM3.53211 5.70263C3.65238 5.48462 3.89972 5.33333 4.18187 5.33333H15.8181C16.1003 5.33333 16.3476 5.48461 16.4679 5.70263L10 9.8529L3.53211 5.70263ZM16.5454 7.28044V14C16.5454 14.3651 16.2165 14.6667 15.8181 14.6667H4.18187C3.78353 14.6667 3.4546 14.3651 3.4546 14V7.28044L10 11.4804L16.5454 7.28044Z"
        fill={fill}
      />
    </svg>
  );
};

export default NewsletterIcon;
